/* eslint-disable react-hooks/exhaustive-deps */
import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addedDidYouMeanToSearchBox } from "../../actions/searchBoxAction";
import { contextProductFinderSuggestions, contextProductFinderSuggestionsCR } from "../../controllers/contextControllers";
import { breakpointUI, useDebounce } from "../../utils/utils";
import ProductFinderSuggestion from "./ProductFinderSuggestion";
import "../SupportSearchHero/SupportSearchHero.scss";

let ProductFinderSearchBox: FunctionComponent<any> = (
  props
) => {
  const { searchBoxSuggestionController } = props.suggestionController;
  const { resultListSuggestionController, productFinderResultListFirstSuggestion, searchBoxProductFinderFirstSuggestion } = props.suggestionController;
  const [openResultSuggestion, setOpenResultSuggestion] = useState(false);
  const [state, setState] = useState(searchBoxSuggestionController.state);
  const [stateDidYouMean, setStateDidYouMean] = useState(props.suggestionController.didYouMeanController.state);
  const [currentValue, setCurrentValue] = useState('');
  const [isDidYouMean, setIsDidYouMean] = useState(false);
  const [activeSuggestions, setActiveSuggestions] = useState(false);
  const [valueSuggestionsActive, setValueSuggestionsActive] = useState('');
  const [isApplyDidYouMean, setIsApplyDidYouMean] = useState(false);
  const debouncedSearchTerm = useDebounce(currentValue);
  const stateDidYouMeanPrev = useSelector((state: any) => state.searchBoxReducer.stateDidYouMean);
  const dispatch = useDispatch();
  const [stateResultsList, setStateResultsList] = useState(props.suggestionController.productFinderResultListFirstSuggestion.state.results);
  useEffect(() => {
    if (debouncedSearchTerm) {
      updateProductFinderSuggestion(debouncedSearchTerm);
    }
  },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );
  useEffect(()=>{
    if(activeSuggestions){
      setCurrentValue(valueSuggestionsActive);
      setActiveSuggestions(false);
    }
  },[activeSuggestions])
  useMemo(() => {
    if (!isDidYouMean) {
      dispatch(addedDidYouMeanToSearchBox({ stateDidYouMean: '' }));
    }
  }, [
    isDidYouMean
  ]);
  useMemo(() => {
    if (isApplyDidYouMean) {
      setCurrentValue(stateDidYouMean.queryCorrection.correctedQuery);
      setIsApplyDidYouMean(false);
    }
  }, [
    isApplyDidYouMean
  ]);
  useEffect(() => props.suggestionController.didYouMeanController.subscribe(() => {
    setStateDidYouMean(props.suggestionController.didYouMeanController.state);

  }
  ), []);
  useEffect(() => props.suggestionController.didYouMeanController.subscribe(() => {
    if (stateDidYouMean.queryCorrection.correctedQuery !== '') {
      setIsDidYouMean(true);
      dispatch(addedDidYouMeanToSearchBox({ stateDidYouMean: stateDidYouMean.queryCorrection.correctedQuery }));
      // setCurrentValue(stateDidYouMean.queryCorrection.correctedQuery);
    }else{
      dispatch(addedDidYouMeanToSearchBox({ stateDidYouMean: '' }));
    }

  }
  ), [stateDidYouMean.queryCorrection.correctedQuery]);

  useEffect(() => productFinderResultListFirstSuggestion.subscribe(() => {
    // if (productFinderResultListFirstSuggestion.state.results.length > 0) {
      setStateResultsList(productFinderResultListFirstSuggestion.state.results);
    // }
  }), []);

  useEffect(() => {
    if (resultListSuggestionController.state.results.length == 0 && !isDidYouMean && state.suggestions.length > 0) {
      contextProductFinderSuggestionsCR.add(`${contextFlag}`, `${contextFlag}`);
      searchBoxProductFinderFirstSuggestion.updateText(state.suggestions[0].rawValue);
      searchBoxProductFinderFirstSuggestion.submit();
    }
  }, [resultListSuggestionController.state.results]);

  useMemo(() => {
    if (currentValue.length < 3) {
      setOpenResultSuggestion(false);
    }
  }, [currentValue]);
  // get attribute from dialog
  let componentProperties = document
    .querySelector("#product-finder-search-box-id")
    ?.getAttribute("supportLandingPage");

  let contextFlag = "";
  switch (componentProperties) {
    case "aem_manuals_flag":
      contextFlag = "manuals";
      break;
    case "aem_advisories_flag":
      contextFlag = "advisories";
      break;
    case "aem_operating_system_compatibility_flag":
      contextFlag = "operatingSystem";
      break;
    case "aem_wireless_help_flag":
      contextFlag = "wirelessHelp";
      break;
    case "where_to_buy_flag":
      contextFlag = "whereToBuy";
      break;
    case "eos_flag":
      componentProperties = "aem_software_drivers_flag";
      contextFlag = "eosUtilities";
      break;
    case "retired_product":
      componentProperties = "oosl";
      contextFlag = "oosl";
      break;
    default:
      componentProperties = "aem_software_drivers_flag";
      contextFlag = "softwareDrivers";
      break;
  }

  useEffect(() => {
    searchBoxSuggestionController.subscribe(() => setState(searchBoxSuggestionController.state));
  }, [searchBoxSuggestionController]);

  // clear input text
  function clearValue() {
    setState({
      ...state,
      value: "",
    });
    setCurrentValue('');
    setOpenResultSuggestion(false);
  }

  // Close suggestions modal when clicking out of the search input.
  document.onclick = (e: any) => {
    const searchInput = document.querySelector("#product-finder-search-box-" + componentProperties);
    if (searchInput && !searchInput.contains(e.target)) {
      setOpenResultSuggestion(false);
    }
  };

  let placeHolder = "Start typing your product name (e.g. EOS 5D Mark II)";

  // Update the placeHolder text in mobile view to ignore overflow text.
  if (window.innerWidth < breakpointUI.mobile) {
    placeHolder = "Start typing product name...";
  }

  const updateProductFinderSuggestion = (e: any) => {
    setState({
      ...state,
      value: e
    });
    if (isDidYouMean && currentValue !== stateDidYouMean.queryCorrection.correctedQuery) {
      setIsDidYouMean(false);
    }
    if (e.length > 2 && contextFlag) {
      // Set environment value
      // contextProductFinderSuggestions.add('environment', envValue);
      // Set SPDP filter value from AEM component dialog
      contextProductFinderSuggestions.add(`${contextFlag}`, `${contextFlag}`);
      searchBoxSuggestionController.updateText(e);
      searchBoxSuggestionController.submit();
      setOpenResultSuggestion(true);
    } else if (openResultSuggestion) {
      setOpenResultSuggestion(false);
    }
  };

  return (
    <div className="search-hero-button-form">
      <div className="search-hero-form-container">
        <input
          id={"product-finder-search-box-" + componentProperties}
          className="search_hero_input form-control mr-sm-2 product-finder-input focus-border-none product-finder-bottom"
          value={currentValue}
          placeholder={placeHolder}
          onChange={(e) => {
            setCurrentValue(e.target.value);
          }}
        />
        {openResultSuggestion && (
          <ProductFinderSuggestion
            setValueSuggestionsActive={setValueSuggestionsActive}
            setActiveSuggestions={setActiveSuggestions}
            setIsApplyDidYouMean={setIsApplyDidYouMean}
            value={state.value}
            resultList={resultListSuggestionController.state.results}
            resultListFirstSuggestion={stateResultsList}
            firstSuggestion={state.suggestions[0]?.rawValue}
            didYouMean={stateDidYouMeanPrev}
            anchor={componentProperties}
            controller={searchBoxSuggestionController}
          />
        )}
        <button className="btn search_hero_btn">
          <div className="icon icon-search"></div>
        </button>
        {currentValue.length > 0 && (
          <div className="close-search-image-container">
            <div
              className="close-search-image"
              aria-label="Close"
              onClick={clearValue}></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductFinderSearchBox;